(() => {
  const BAD_ORIGINS = [
    'https://completecareshop-staging.myshopify.com',
    'https://completecareshop-qa.myshopify.com',
  ];
  const PUBLIC_ORIGIN = 'https://completecareshop.co.uk';

  const replaceOrigin = (value) => {
    if (typeof value !== 'string') return value;

    const badOrigin = BAD_ORIGINS.find((origin) => value.startsWith(origin));

    return badOrigin ? PUBLIC_ORIGIN + value.slice(badOrigin.length) : value;
  };

  const asArray = (value) => {
    if (value == null) return [];

    return Array.isArray(value) ? value : [value];
  };

  const findThemeProductSchema = () => {
    const scripts = document.querySelectorAll('script[type="application/ld+json"]');

    for (const script of scripts) {
      let schema;

      try {
        schema = JSON.parse(script.textContent);
      } catch {
        continue;
      }

      if (
        (schema['@type'] === 'Product' || schema['@type'] === 'ProductGroup') &&
        typeof schema['@id'] === 'string' &&
        schema['@id'].includes('#product')
      ) {
        return schema;
      }
    }

    return null;
  };

  const findThemeOffer = (themeProduct, sku) => {
    if (!themeProduct) return null;

    const variants = asArray(themeProduct.hasVariant);
    const matchingVariant = variants.find((variant) => variant.sku && sku && variant.sku === sku);
    const variantOffer = matchingVariant?.offers;

    return variantOffer || themeProduct.offers || variants[0]?.offers || null;
  };

  const fixSchema = (root) => {
    const scripts = [];

    if (
      root?.nodeType === Node.ELEMENT_NODE &&
      root.matches?.('script[type="application/ld+json"]')
    ) {
      scripts.push(root);
    }

    root?.querySelectorAll?.('script[type="application/ld+json"]').forEach((script) => scripts.push(script));

    scripts.forEach((script) => {
      let schema;

      try {
        schema = JSON.parse(script.textContent);
      } catch {
        return;
      }

      if (schema['@type'] !== 'Product') return;

      const oldUrl = schema.url;
      const oldOfferUrl = schema.offers?.url;
      const oldBrand = schema.brand;
      const oldAvailability = schema.offers?.availability;
      const oldItemCondition = schema.offers?.itemCondition;
      const oldPrice = schema.offers?.price;
      const oldPriceCurrency = schema.offers?.priceCurrency;

      const themeProduct = findThemeProductSchema();
      const themeOffer = findThemeOffer(themeProduct, schema.sku);

      if (typeof schema.brand === 'string' && schema.brand.trim() !== '') {
        schema.brand = {
          '@type': 'Brand',
          name: schema.brand,
        };
      }

      schema.url = replaceOrigin(schema.url);

      if (schema.offers) {
        schema.offers.url = replaceOrigin(schema.offers.url);

        if (themeOffer) {
          schema.offers.availability = themeOffer.availability || schema.offers.availability;
          schema.offers.itemCondition = themeOffer.itemCondition || schema.offers.itemCondition;
          schema.offers.price = themeOffer.price || schema.offers.price;
          schema.offers.priceCurrency = themeOffer.priceCurrency || schema.offers.priceCurrency;

          if (themeOffer.priceSpecification) {
            schema.offers.priceSpecification = themeOffer.priceSpecification;
          }
        }
      }

      if (
        schema.url !== oldUrl ||
        schema.offers?.url !== oldOfferUrl ||
        schema.brand !== oldBrand ||
        schema.offers?.availability !== oldAvailability ||
        schema.offers?.itemCondition !== oldItemCondition ||
        schema.offers?.price !== oldPrice ||
        schema.offers?.priceCurrency !== oldPriceCurrency
      ) {
        script.textContent = JSON.stringify(schema);
      }
    });
  };

  const start = () => {
    fixSchema(document);

    new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach(fixSchema);
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
